import React from 'react'
import hooks from '../../../hooks'

const useLearningResourceView = ({ id }) => {

    const { endpoints, url } = hooks.useApi()
    const { windowLocation } = hooks.useClientLocation()
    const { id: user } = hooks.useCurrentUser()

    const goToResource = React.useCallback(async () => {
        windowLocation(url(endpoints.learningResourceView, { resourceId: id }, { user }), true)
        
    }, [id, windowLocation])

    return {
        goToResource
    }
}

export default useLearningResourceView
